import React from "react";
import ReactDOM from "react-dom/client";
import AuthGate from "./Auth";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthGate>
    {function (authProps) {
      return <App
        user={authProps.user}
        userDoc={authProps.userDoc}
        companyId={authProps.companyId}
        companyName={authProps.companyName}
        membership={authProps.membership}
        onLogout={authProps.onLogout}
        onSwitchCompany={authProps.onSwitchCompany}
      />;
    }}
  </AuthGate>
);
